$(document).ready(function(){
  $('.testimonial-slider').slick({
    infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
    autoplay: true,
  autoplaySpeed: 5000,
    accessibility: false,
  });
  
  
  /*** Filter Slides ***/
  // Home
  $('.testimonial-slider.all').slick('slickFilter','.home,.all');
  
  // About
  $('.testimonial-slider.about').slick('slickFilter','.about,.all');
  
  // Geka
  $('.testimonial-slider.geka').slick('slickFilter','.geka,.all');
  
  // Scotchman
  $('.testimonial-slider.scotchman').slick('slickFilter','.scotchman,.all');
  
  // Piranha
  $('.testimonial-slider.piranha').slick('slickFilter','.piranha,.all');
  
  // Edwards
  $('.testimonial-slider.edwards').slick('slickFilter','.edwards,.all');
  
  // Amada Marvel
  $('.testimonial-slider.marvel').slick('slickFilter','.marvel,.all');
  
  // Ficep
  $('.testimonial-slider.ficep').slick('slickFilter','.ficep,.all');
  
  // Sunrise
  $('.testimonial-slider.sunrise').slick('slickFilter','.sunrise,.all');
  
  // Voortman
  $('.testimonial-slider.voortman').slick('slickFilter','.voortman,.all');
  
    // Voortman
  $('.testimonial-slider.punch-easy').slick('slickFilter','.punch-easy,.all');
  
  /* Add more filters for each featured machine page */
});